import RestrictedTooltip, { AccessValidation } from './permissions/RestrictedTooltip';
import React from 'react';
import { PropsWithChildren } from 'react';
import { usePermissions } from '../../permissions/usePermissions';

//This component is adding a tooltip and a "disabled" prop to the children, according to the user's permissions
const WithPermissions = (
  props: PropsWithChildren<{
    accessValidation: AccessValidation;
    disabledTooltip: string;
  }>,
) => {
  const { children, accessValidation, disabledTooltip } = props;
  const { hasEveryPermission } = usePermissions();

  let isAllowed = false;
  if (accessValidation.type === 'explicit') {
    isAllowed = accessValidation.allowed;
  } else {
    isAllowed = hasEveryPermission(accessValidation.queries);
  }

  const childrenWithProps = React.isValidElement(children)
    ? React.cloneElement(children, {
      ...children.props,
      disabled: !isAllowed,
    })
    : undefined;

  return (
    <RestrictedTooltip validation={accessValidation} notAllowedTitle={disabledTooltip}>
      {childrenWithProps}
    </RestrictedTooltip>
  );
};

export default WithPermissions;
